import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56e79ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Remove the relationship to this parent? ", -1))

import { ref } from 'vue'
import { FamilyRelationshipRole } from '@/rd/ResearchDataModel'
import Modal from '@/util/Modal.vue'
import PersonCard from '../PersonCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileParentRemoveModal',
  emits: ["remove"],
  setup(__props, { expose: __expose, emit }) {



__expose({
  open,
})

const personIdRef = ref<string>()
const roleRef = ref(FamilyRelationshipRole.Father)
const modalRef = ref<InstanceType<typeof Modal>>()

function open(role: FamilyRelationshipRole, personId: string) {
  personIdRef.value = personId
  roleRef.value = role
  modalRef.value?.open()
}

function onConfirm() {
  modalRef.value?.close()
  emit('remove', roleRef.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-style": "danger",
    onOk: onConfirm
  }, {
    title: _withCtx(() => [
      _createTextVNode("Remove parent")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Remove")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(PersonCard, {
        "person-id": personIdRef.value,
        layout: "small",
        "show-profile-type": "",
        "show-profile-count": "multiple",
        static: ""
      }, null, 8, ["person-id"])
    ]),
    _: 1
  }, 512))
}
}

})